module.exports = __webpack_public_path__ + "img/workplay-video-2.ddc49ae4.jpg";